import { ActionTree } from 'vuex'
import { ContactsState } from './contacts.types'
import { getContacts } from '../../services/contacts.service'
import { MutationTypes } from './contacts.mutations'
import { Contact } from './contacts.types'

export const actions: ActionTree<ContactsState, unknown> = {
  async getContacts({ commit }) {
    try {
      const contacts: Contact[] = await getContacts()
      commit(MutationTypes.SET_CONTACTS, contacts)
    } catch (err) {
      commit(MutationTypes.SET_CONTACT_GET_ERROR, err)
    }
  }
}
